import React, {Component} from 'react';
import {Container, Grid} from 'semantic-ui-react';
import Thumbnail from '../../components/Thumbnail';
import Screenshot2Img from './screenshot2.png';

export default class GettingStartedDescription extends Component {
    render() {
        return (<Container>
                <Grid>
                    <Grid.Column width={8}>
                        <h2>What do you get?</h2>
                        <p><a href="https://aws.amazon.com/cloudwatch/" target="_blank">AWS CloudWatch</a> exposes numerous
                            useful metrics for your EC2 instances by default.
                            Making them visible, however, can be a tedious work.</p>
                        <p>By calling our service's endpoint you can automatically create AWS CloudWatch dashboards for all
                            or
                            some of the EC2 instances you own.
                            The API supports choosing a region as well as a regex-based name filtering.</p>
                        <p>
                            Our endpoint will also take care of visualizing your EBS volume's metrics, linking them to the
                            respective EC2 instances and labelling the dashboards correctly.
                        </p>
                        <Thumbnail image={Screenshot2Img} />
                    </Grid.Column>
                    <Grid.Column width={8}>
                    </Grid.Column>
                </Grid>
            </Container>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/pages/GettingStarted/GettingStartedDescription.js
 **/